<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/equipo.png">
  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">¿QUIÉNES SOMOS?</h1>
    </div>
  </div>
</header>

<section class="section-bg-dark scroll-animations parallax-container" data-parallax="scroll" data-bleed="10"
  data-speed="0.2" data-natural-width="1400" data-natural-height="1400">
  <div class="container">
    <div class="row animated">
      <div class="col">
        <h2 class="section-title-clear">El equipo Zeeker</h2>
        <hr class="line">
        <p class="section-text-clear">
          Contamos con un equipo multidisplinar especializado en diferentes áreas digitales para ofrecer el soporte y
          mantenimiento necesario en cada proyecto.
        </p>
        <p class="section-text-clear">
          Nuestra forma de trabajo se inicia con el proceso de evaluación para hacer posible la toma de
          decisiones, la definición de estrategias y la adopción de las soluciones tecnológicas más adecuadas
          para cada negocio.
        </p>
      </div>
    </div>
  </div>
</section>

<section id="team" class="section-bg-clear">
  <div class="container">
    <div class="row">
      <!-- <h2 class="section-title-black align__element-center w-100">Nuestro equipo de trabajo</h2> -->
      <p class="header_subtitle"> La clave del éxito de Zeeker es su personal integrado.</p>
      <br><br><br>
    </div>
    <div class="row">
      @for (card of cards; track card) {
              <div class="col-xs-12 col-sm-6 col-md-4 text-center icons_container">
        <div class="icons_standar icons_gray">

          <img src="{{ card.icon }}" alt="icon" class="filter">
        </div>
        <div class="icon_text">
          <h3 class="icon-title">{{ card.title }}</h3>
          <hr class="line_animated">
          <p class="icon_paragraph">{{ card.description }}</p>
        </div>
      </div>
      }
    </div>
  </div>
</section>

<section id="pmo" class="scroll-animations pb-5 skills">
  <div class="container">
    <div class="row">
      <div class="col">
        <br>
        <h2 class="w-100">¿Qué hacemos?</h2>
        <br>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-xs-12">
        <p>Ayudamos a las empresas a avanzar en su transformación digital — incluyendo la adopción de inteligencia artificial — con estrategia clara, talento especializado
          y las mejores soluciones tecnológicas del mercado.
        </p>
      </div>
      <div class="col-sm-12 col-xs-12">
        <p>Cubrimos todo el ciclo: desde el diagnóstico y la estrategia hasta la incorporación de perfiles especializados
          y la implantación de soluciones tecnológicas líderes, con o sin IA.</p>
      </div>
    </div>
    <div class="row">
      @for (funcionality of funcionalities; track funcionality) {
        <div class="col-sm-12 col-md-6 col-lg-3 text-center p-2">
        <img src="{{ funcionality.icon }}" alt="" class="card-img-top">
        <div class="card-body">
          <div class="border_box">
            <h5>{{ funcionality.title }}</h5>
            <p>{{ funcionality.description }}</p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="container">
    <div class="row justify__content-center">
      <div class="col-6 mt-10">
        <button class="btn_help" routerLink="/contacto">¿Te ayudamos?</button>
      </div>
    </div>
  </div>

</section>